import { useEffect } from "react";

import { useSelectedDealer } from "components";
import { useTypedQuery } from "hooks";
import { CheckInServicesQueryKeys } from "modules/CheckInServices/queryKeys";
import { ApiInstance } from "utils/Api";

import type { CheckInService } from "models";

const sortCheckInServices = (checkInServices: CheckInService[]) => checkInServices.sort((a, b) => b.id - a.id);

export const useCheckInServicesQuery = () => {
  const { selectedDealer } = useSelectedDealer();

  const query = useTypedQuery({
    queryKey: CheckInServicesQueryKeys.dealerList,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_id: selectedDealer?.id }, baseUrl)).data.check_in_services,
    select: sortCheckInServices,
    enabled: false
  });

  useEffect(() => {
    if (selectedDealer?.id) query.refetch();
  }, [selectedDealer?.id]);

  return query;
};
